module.exports = __webpack_public_path__ + "img/en.6dc24608.png";